/* DATA of management */
export const PEOPLE = [
	{ name: 'john' },
	{ name: 'steven' },
	{ name: 'ian' },
]